import { render } from "./PartnersView.vue?vue&type=template&id=45c1bf25"
import script from "./PartnersView.vue?vue&type=script&lang=js"
export * from "./PartnersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__